import { FC } from 'react';

import { Users } from 'lucide-react';
import { isEmpty, isNonNullish } from 'remeda';
import useSWR from 'swr';

import Chip from '@mui/material/Chip';
import Pagination from '@mui/material/Pagination';

import css from './Referrals.module.css';

import { referralsService } from 'v2/api/referralsService';
import { EmptyPlaceholder } from 'v2/components/emptyPlaceholder/EmptyPlaceholder';
import { ProfileCard } from 'v2/components/profileCard/ProfileCard';
import { UserLink } from 'v2/components/userLink/UserLink';
import { usePagination } from 'v2/hooks/usePagination';
import { getPaginationCount } from 'v2/utils';

interface ReferralsProps {
  userId: string;
}

export const Referrals: FC<ReferralsProps> = ({ userId }) => {
  const { page, pageSize, onPageChange } = usePagination({ defaultPageSize: 10 });

  const { data } = useSWR(['getUserReferrals', page, pageSize, userId], referralsService.getUserReferrals, {
    keepPreviousData: true,
  });

  return (
    <ProfileCard title="Referrals" icon={<Users width={18} height={18} />}>
      {isNonNullish(data) && (
        <>
          {isEmpty(data.result) ? (
            <EmptyPlaceholder />
          ) : (
            <>
              {data.result.map((referral) => (
                <UserLink
                  key={referral.id}
                  extra={
                    <span className={css.extra}>
                      {referral.isSuspicious && <Chip label="SAME FP" size="small" color="error" />}

                      <Chip label={`${referral.completedTasksCount} daily tasks`} size="small" />
                    </span>
                  }
                  highlighted={referral.isSuspicious}
                  imgUrl={referral.imgUrl}
                  nickname={referral.userNickname}
                  userId={referral.id}
                />
              ))}

              {data.total > pageSize && (
                <Pagination
                  className={css.pagination}
                  page={page}
                  count={getPaginationCount(pageSize, data.total)}
                  onChange={(_, p) => onPageChange(p)}
                />
              )}
            </>
          )}
        </>
      )}
    </ProfileCard>
  );
};
